// Off canvas menu
$(document).offcanvas();

// Prevent 300ms click delay
FastClick.attach(document.body);